import AsyncPage from 'pages/AsyncPage'
import { clearSuggestions } from 'actions/mentions'
import universal from 'react-universal-component'
import log from 'lib/log'
import { loadGroup } from 'actions/groups'
const component = universal(props => import('./GroupEditPage'))

class AsyncGroupEditPage extends AsyncPage {
  constructor() {
    super({
      pageComponent: component
    })
  }
  async prepareAdditionalAsyncData(dispatch, getState, opts) {
    const {
      location: { type: place, payload: { group: groupId } },
      group: { value: group }
    } = getState()
    if (!group || group._id !== groupId) {
      try {
        let result = await loadGroup({ _id: groupId })(dispatch, getState, opts)
      } catch (e) {
        log.error(e)
      }
    }
  }
}

export default new AsyncGroupEditPage()
